import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeatureMapMarkerComponent } from './feature-map-marker.component';
import { MotePipesModule } from '../../pipes/mote-pipes.module';
import { SvgIconModule } from '../svg-icon';

@NgModule({
    declarations: [FeatureMapMarkerComponent],
    imports: [
        CommonModule,
        MotePipesModule,
        SvgIconModule
    ],
    exports: [FeatureMapMarkerComponent]
})
export class FeatureMapMarkerModule { }
